export default class TripadvisorRatingSummary extends HTMLElement {

    connectedCallback()
    {
        this.stylesheet = this.getAttribute('stylesheet');
        this.ratingImg = this.getAttribute('ratingImg');
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const tripadvisorRatingSummary = document.querySelector('#tripadvisor-rating-summary');
        const instance = tripadvisorRatingSummary.content.cloneNode(true);
        if (this.stylesheet !== undefined)
        {
            instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
            instance.querySelector('[data-entity="tripadvisor-img"]').src = this.ratingImg;
            this._shadowRoot.appendChild(instance);
        }
        return this._shadowRoot;
    }
}
